module.exports = __webpack_public_path__ + "img/HQ-Z7035-V1.787b2ab1.jpg";